import { Trash } from "iconsax-react";
import { useParams } from "react-router-dom";

import { Box, Image, Text } from "@chakra-ui/react";
import React, { useState, useEffect, useCallback } from "react";
import { VscCopy } from "react-icons/vsc";
import { useSnackbar } from "notistack";
import api from "../../../../api";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MoonLoader } from "react-spinners";

const AcademicDetails = () => {
  const { id } = useParams();
  const [userDetails, setUserDetails] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [isLoadinge, setIsLoadinge] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [filesi, setFiles] = useState(null);
  const [isDeclarationAccepted, setIsDeclarationAccepted] = useState(false);

  function range(start, end, step) {
    const result = [];
    for (let i = start; i <= end; i += step) {
      result.push(i);
    }
    return result;
  }

  useEffect(() => {
    if (id) {
      api
        .getUserbyid(id)
        .then((response) => {
          setUserDetails(response.data);
        })
        .catch((error) => {
          enqueueSnackbar("Error fetching staff details", { variant: "error" });
        });
    }
  }, [id]);

  const [formValues, setFormValues] = useState({
    q1_name_of_institution: "",
    q1_qualification: "",
    q1_start_year: "",
    q1_end_year: "",
    q1_document_file: "",
    q2_name_of_institution: "",
    q2_qualification: "",
    q2_start_year: "",
    q2_end_year: "",
    q2_document_file: "",
  });

  const onFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const onFileChanges = (e) => {
    setFiles(e.target.files[0]);
  };
  const [academic, setAcademic] = useState([
    {
      id: "0",
      name_of_institution: "",
      qualification: "",
      start_year: "",
      end_year: "",
    },
  ]);

  const handleAcademic = () => {
    setAcademic([
      ...academic,
      {
        id: JSON.stringify(academic?.length + 1),
        name_of_institution: "",
        qualification: "",
        start_year: "",
        end_year: "",
      },
    ]);
  };
  const handleAcademicChange = (index, event) => {
    const { name, value } = event.target;
    const newAcademic = [...academic];
    newAcademic[index][name] = value;
    setAcademic(newAcademic);
  };

  useEffect(() => {
    if (userDetails) {
      setAcademic(userDetails?.staff_academic_qualification);
    }
  }, [userDetails]);

  const handleDeclarationChange = () => {
    setIsDeclarationAccepted(!isDeclarationAccepted);
  };
  const isSaveButtonDisabled = !isDeclarationAccepted || isLoading;

  async function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);

    const formData = new FormData();
    // formData.append("q1_document_file", file);
    // formData.append("q2_document_file", filesi);

    // formData.append("qualifications",  academic);
    academic.forEach((acad, index) => {
      formData.append(`qualifications`, JSON.stringify(acad)); // Send each item as "items[]"
    });

    try {
      const response = await api.updateAinfo({ qualifications: academic });
      console.log("responce==>>>>>", response);
      enqueueSnackbar("Information updated successfully", {
        variant: "success",
      });
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      enqueueSnackbar(error.message, { variant: "error" });
      setIsLoading(false);
    }
  }

  const removeItem = (idToRemove) => {
    const updatedItems = academic.filter((item) => item.id !== idToRemove);
    setAcademic(updatedItems); // Update state with the new array
  };
  return (
    <div>
      {isLoadinge ? (
        <Box
          w={"85vw"}
          display="flex"
          flexDirection="column"
          h={"75vh"}
          alignItems="center"
          justifyContent="center"
        >
          <div
            className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-70"
            style={{ zIndex: 9999 }}
          >
            <div className="inline-block">
              <MoonLoader color={"#984779"} size={80} />
            </div>
          </div>
        </Box>
      ) : (
        <div className="min-h-screen bg-gray-50 p-4">
          <form
            onSubmit={handleSubmit}
            className="max-w-4xl mx-auto bg-white rounded-lg shadow-sm p-6"
          >
            <div className="border-bottom pb-6">
              <div className="flex flex-col lg:flex-row gap-6">
                <div className="lg:w-1/3">
                  <Text color={"black"} className="text-lg font-semibold mb-2">
                    Academic/Professional Qualification
                  </Text>
                </div>
                <div className="lg:w-2/3">
                  {academic?.map((acad, index) => (
                    <div
                      key={index}
                      className="bg-white border border-gray-200 rounded-lg p-4 mb-4 shadow-sm"
                    >
                      <div className="space-y-4">
                        <div className="form-group">
                          <label className="flex justify-between items-center text-sm font-medium text-gray-700 mb-2">
                            Name of institution
                          </label>
                          <input
                            type="text"
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#984779]"
                            placeholder=""
                            required
                            name="name_of_institution"
                            value={acad.name_of_institution}
                            onChange={(event) =>
                              handleAcademicChange(index, event)
                            }
                          />
                        </div>
                        <div className="form-group">
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            Qualification
                          </label>
                          <input
                            type="text"
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#984779]"
                            placeholder=""
                            name="qualification"
                            value={acad.qualification}
                            onChange={(event) =>
                              handleAcademicChange(index, event)
                            }
                          />
                        </div>
                        <div className="form-group">
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            End Year
                          </label>
                          <input
                            type="text"
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#984779] disabled:bg-gray-100"
                            placeholder=""
                            name="end_year"
                            value={acad.end_year}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                  {/* 
                <button
                  type="button"
                  className="btn py-1 px-4 mt-4  mb-2 text-white rounded-md"
                  style={{ backgroundColor: "#17082d" }}
                  onClick={handleAcademic}
                >
                  Add More Qualification
                </button> */}
                </div>
              </div>

              {/* 

            <div className="row mt-4 border-bottom pb-4">
              <div className="col-lg-4">
                <p className="fs-5 pt-2 fw-semibold">Other Degrees</p>
              </div>
              <div className="col-lg-6 pe-">
                <div class="form-group">
                  <label
                    for="exampleFormControlSelect1"
                    className="fw-semibold text-muted fs-6 mt-3 mb-2"
                  >
                    Name of institution
                  </label>
                  <input
                    type="text"
                    style={{ height: "40px" }}
                    class="form-control rounded-0"
                    id="exampleFormControlInput1"
                    placeholder=""
                    value={formValues.q2_name_of_institution}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        q2_name_of_institution: e.target.value,
                      })
                    }
                  />
                </div>
                <div class="form-group">
                  <label
                    for="exampleFormControlSelect1"
                    className="fw-semibold text-muted fs-6 mt-3 mb-2"
                  >
                    Qualification
                  </label>
                  <input
                    type="text"
                    style={{ height: "40px" }}
                    class="form-control rounded-0"
                    id="exampleFormControlInput1"
                    placeholder=""
                    value={formValues.q2_qualification}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        q2_qualification: e.target.value,
                      })
                    }
                  />
                </div>

                <div class="row">
                  <div className="col-lg-5">
                    <div class="form-group">
                      <label
                        for="exampleFormControlSelect1"
                        className="fw-semibold text-muted fs-6 mt-3 mb-2"
                      >
                        Start Date
                      </label>
                      <DatePicker
                        renderCustomHeader={({
                          date,
                          changeYear,
                          changeMonth,
                          decreaseMonth,
                          increaseMonth,
                          prevMonthButtonDisabled,
                          nextMonthButtonDisabled,
                        }) => (
                          <div
                            style={{
                              margin: 10,
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <button
                              onClick={decreaseMonth}
                              disabled={prevMonthButtonDisabled}
                            >
                              {"<"}
                            </button>
                            <select
                              value={getYear(date)}
                              onChange={({ target: { value } }) =>
                                changeYear(value)
                              }
                            >
                              {years.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>

                            <select
                              value={months[getMonth(date)]}
                              onChange={({ target: { value } }) =>
                                changeMonth(months.indexOf(value))
                              }
                            >
                              {months.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>

                            <button
                              onClick={increaseMonth}
                              disabled={nextMonthButtonDisabled}
                            >
                              {">"}
                            </button>
                          </div>
                        )}
                        selected={
                          formValues.q2_start_year
                            ? new Date(formValues.q2_start_year)
                            : null
                        }
                        onChange={(date) => {
                          if (date instanceof Date && !isNaN(date)) {
                            const formattedDate = date
                              .toISOString()
                              .split("T")[0];
                            setFormValues({
                              ...formValues,
                              q2_start_year: formattedDate,
                            });
                          } else {
                            setFormValues({
                              ...formValues,
                              q2_start_year: "",
                            });
                          }
                        }}
                        dateFormat="yyyy-MM-dd"
                        className="form-control rounded-0"
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div className="col-lg-5">
                    <div class="form-group">
                      <label
                        for="exampleFormControlSelect1"
                        className="fw-semibold text-muted fs-6 mt-3 mb-2"
                      >
                        End Date
                      </label>
                      <DatePicker
                        renderCustomHeader={({
                          date,
                          changeYear,
                          changeMonth,
                          decreaseMonth,
                          increaseMonth,
                          prevMonthButtonDisabled,
                          nextMonthButtonDisabled,
                        }) => (
                          <div
                            style={{
                              margin: 10,
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <button
                              onClick={decreaseMonth}
                              disabled={prevMonthButtonDisabled}
                            >
                              {"<"}
                            </button>
                            <select
                              value={getYear(date)}
                              onChange={({ target: { value } }) =>
                                changeYear(value)
                              }
                            >
                              {years.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>

                            <select
                              value={months[getMonth(date)]}
                              onChange={({ target: { value } }) =>
                                changeMonth(months.indexOf(value))
                              }
                            >
                              {months.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>

                            <button
                              onClick={increaseMonth}
                              disabled={nextMonthButtonDisabled}
                            >
                              {">"}
                            </button>
                          </div>
                        )}
                        selected={
                          formValues.q2_end_year
                            ? new Date(formValues.q2_end_year)
                            : null
                        }
                        onChange={(date) => {
                          if (date instanceof Date && !isNaN(date)) {
                            const formattedDate = date
                              .toISOString()
                              .split("T")[0];
                            setFormValues({
                              ...formValues,
                              q2_end_year: formattedDate,
                            });
                          } else {
                            setFormValues({
                              ...formValues,
                              q2_end_year: "",
                            });
                          }
                        }}
                        dateFormat="yyyy-MM-dd"
                        className="form-control rounded-0"
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                  </div>
                </div>
                <div className=" h-90 w-100 d-flex align-items-center justify-content-space">
                  <div className="form-group">
                    <label
                      htmlFor={`q2_document`}
                      className="fw-semibold text-muted fs-6 mt-3 mb-2"
                    >
                      Upload Document
                    </label>
                    <input
                      type="file"
                      className="form-control rounded-0"
                      id={`q2_document`}
                      onChange={onFileChanges}
                    />
                    {userDetails.q2_document_file &&
                    userDetails.q2_document_file.trim() !== "" &&
                    !userDetails.q2_document_file.endsWith("null") ? (
                      <div className="mt-2">
                        <a
                          href={userDetails.q2_document_file}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Document
                        </a>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-lg-2"></div>
            </div> */}
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default AcademicDetails;
